var $ = require('../internals/export');

var global = require('../internals/global');

var microtask = require('../internals/microtask');

var classof = require('../internals/classof-raw');

var process = global.process;
var isNode = classof(process) == 'process'; // `queueMicrotask` method
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask

$({
  global: true,
  enumerable: true,
  noTargetGet: true
}, {
  queueMicrotask: function queueMicrotask(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});